function addCookiePreferencesButtonToFooter(footer, buttonText) {
    const container = document.createElement("div");
    container.className = "ot-sdk-btn";
    const button = document.createElement("button");
    button.className = "ot-sdk-show-settings";
    button.id = "ot-sdk-btn";
    button.innerHTML = buttonText;
    container.appendChild(button);
    footer.appendChild(container);
    return container;
}
function insertCookieConsentScripts(domainUuid) {
    const autoBlockScript = document.createElement("script");
    const sdkScript = document.createElement("script");
    autoBlockScript.type = "text/javascript";
    autoBlockScript.src = `https://cdn.cookielaw.org/consent/${domainUuid}/OtAutoBlock.js`;
    sdkScript.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
    sdkScript.dataset.documentLanguage = "true";
    sdkScript.type = "text/javascript";
    sdkScript.charset = "UTF-8";
    sdkScript.dataset.domainScript = domainUuid;
    document.head.insertBefore(autoBlockScript, document.head.firstChild);
    document.head.insertBefore(sdkScript, autoBlockScript.nextSibling);
}
export default function (domainUuid, buttonText) {
    const footer = document.querySelector([
        "body>footer",
        "body>prism-layout [slot=footer]",
        "body>prism-layout>section>footer",
    ].join(","));
    if (footer) {
        addCookiePreferencesButtonToFooter(footer, buttonText);
        insertCookieConsentScripts(domainUuid);
    }
}
